import React, { Component } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import AuthStore from '../../Auth/AuthStore';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import './report.css';
import { Button, IconButton, TextField } from '@mui/material';
import DownloadIcon from '@mui/icons-material/CloudDownload';
import ProjectSelect from '../Projects/ProjectSelect';
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';
import Grow from '@mui/material/Grow';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import UserSelect from '../Users/UserSelect';
import MainStore from '../../../MainStore';

export class ExtendedHierarchicalReport extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            start: this.formatDate(new Date()),
            end: this.formatDate(new Date()),
            project: null,
            projectId: '',
            projects: [],
            user: null
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleProjectChange = this.handleProjectChange.bind(this);
        this.handleUserChange = this.handleUserChange.bind(this);
        this.load = this.load.bind(this);

        //this.loadReport = this.loadReport.bind(this);
    }

    componentDidMount() {
        //this.loadReport();
    }

    handleChange = name => evt => {
        this.setState({[name]: evt.target.value});
    }

    load() {
        MainStore.setMaskVisible();
        var scope = this;
        fetchWithAuth('api/Report/GetHierarchicalReport?start=' + new Date(this.state.start).toISOString() + '&end=' + new Date(this.state.end).toISOString() + '&projectId=' + (this.state.project ? this.state.project.id : '') + '&userId=' + (this.state.user ? this.state.user.id : ''),
            null,
            "",
            (result) => {
                scope.setState({ projects: result });
                MainStore.setMaskUnvisible();
            },
            "GET"
        )
    }

    formatDate(d) {
        var date = new Date(d);
        var month = (date.getMonth() + 1);
        if (month < 10) month = '0' + month;

        var day = date.getDate();
        if (day < 10) day = '0' + day;

        return date.getFullYear() + '-' + month + '-' + day;
    }

    handleProjectChange(project) {
        if (project) {
            this.setState({ project: project, projectId: project.id });
        }
        else {
            this.setState({ project: null, projectId: '' });
        }
    }

    handleUserChange(user) {
        if (user) {
            this.setState({ user: user, userId: user.id });
        }
        else {
            this.setState({ user: null, userId: '' });
        }
    }

    render() {
        return (
            <div className="hierarhical-report-block">
                <TextField
                    InputLabelProps={{ shrink: true }}
                    id="date"
                    label="Start"
                    variant="standard"
                    type="date"
                    value={this.formatDate(this.state.start)}
                    onChange={this.handleChange('start')}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />

                <TextField
                    InputLabelProps={{ shrink: true }}
                    id="date"
                    label="End"
                    variant="standard"
                    type="date"
                    value={this.formatDate(this.state.end)}
                    onChange={this.handleChange('end')}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />

                <ProjectSelect name={this.state.project && this.state.project.name} id={this.state.project && this.state.project.id} key="extendend-hierrarchical-project-select" handleSelect={this.handleProjectChange} />
                <UserSelect name={this.state.user && this.state.user.name} id={this.state.user && this.state.user.id} label="Человек" handleSelect={this.handleUserChange} />

                <div className="clearfix">
                    <Button onClick={this.load} color="primary" className="work-dialog-save-button">
                        Загрузить
                    </Button>
                    <Button onClick={this.load} color="primary" className="work-dialog-save-button">
                        Скачать
                    </Button>
                    <a href={'api/Report/DownloadHierarchicalReport?start=' + new Date(this.state.start).toISOString() + '&end=' + new Date(this.state.end).toISOString() + '&projectId=' + (this.state.project ? this.state.project.id : '') + '&userId=' + (this.state.user ? this.state.user.id : '')} download={'ExtendedReport_' + new Date(this.state.start).toISOString() + ".csv"}><DownloadIcon /></a>
                    <a href={'api/Report/DownloadHierarchicalTopReport?start=' + new Date(this.state.start).toISOString() + '&end=' + new Date(this.state.end).toISOString() + '&projectId=' + (this.state.project ? this.state.project.id : '') + '&userId=' + (this.state.user ? this.state.user.id : '')} download={'ExtendedReport_' + new Date(this.state.start).toISOString() + ".csv"}><DownloadIcon /></a>
                </div>
                <div className="extended-hierarchical-projects">
                    {this.state.projects.map(p => <ExtendedHierarchicalProjectRow key={p.id} project={p} />)}
                </div>
            </div>
        )
    }
}

class ExtendedHierarchicalProjectRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        }
    }

    render() {
        return (
            <div className="extended-hierarchical-project-row" >
                <div className="extended-hierarchical-project-row-data clearfix">
                     <div className="extended-hierarchical-button">
                        {this.props.project.works && this.props.project.works.length > 0 &&
                            <IconButton size="small" onClick={() => { this.setState({ isOpen: !this.state.isOpen }); }}>
                                {this.state.isOpen ? <RemoveIcon fontSize="small" /> : <AddIcon fontSize="small" />}
                            </IconButton>}
                    </div>
                    <div className="extended-hierarchical-project-row-name" >{this.props.project.name}</div>
                    <div className="extended-hierarchical-project-row-time">{this.props.project.factHours.toFixed(2)}</div>
                </div>
                <Grow in={this.state.isOpen}>
                    <div className={" " + (this.state.isOpen ? "" : "null-height")}>
                        {this.props.project.works && this.state.isOpen && this.props.project.works.map(w => <ExtendedHierarchicalProjectWorkRow work={w} key={w.id} />)}
                    </div>
                </Grow>
            </div>
            
        )
    }
}

class ExtendedHierarchicalProjectWorkRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        }
    }

    render() {
        return (
            <div className="extended-hierarchical-parent-work-row" >
                <div className="extended-hierarchical-project-row-data clearfix">
                    <div className="extended-hierarchical-button">
                        {this.props.work.works && this.props.work.works.length > 0 &&
                            <IconButton size="small" onClick={() => { this.setState({ isOpen: !this.state.isOpen }); }}>
                                {this.state.isOpen ? <RemoveIcon fontSize="small" /> : <AddIcon fontSize="small" />}
                            </IconButton>}
                    </div>
                    <div className="extended-hierarchical-project-row-name" onClick={() => { this.setState({ isOpen: !this.state.isOpen }); }}>{this.props.work.number} {this.props.work.name}</div>
                    <div className="extended-hierarchical-project-row-time">{this.props.work.factHours.toFixed(2)}</div>
                </div>
                <Grow in={this.state.isOpen}>
                    <div className={" " + (this.state.isOpen ? "" : "null-height")}>
                        {this.props.work.users && this.state.isOpen && this.props.work.users.map(w => <ExtendedHierarchicalProjectUserRow user={w} key={w.id} />)}

                    </div>
                </Grow >
            </div >
            
        )
    }
}

class ExtendedHierarchicalProjectChildWorkRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        }
    }

    render() {
        return (
            <div className="extended-hierarchical-child-work-row" >
                <div className="extended-hierarchical-project-row-data clearfix">
                    <div className="extended-hierarchical-button">
                        {this.props.work.users && this.props.work.users.length > 0 &&
                            <IconButton size="small" onClick={() => { this.setState({ isOpen: !this.state.isOpen }); }}>
                                {this.state.isOpen ? <RemoveIcon fontSize="small" /> : <AddIcon fontSize="small" />}
                            </IconButton>}
                    </div>
                    <div className="extended-hierarchical-project-row-name" onClick={() => { this.setState({ isOpen: !this.state.isOpen }); }}>{this.props.work.name}</div>
                    <div className="extended-hierarchical-project-row-time">{this.props.work.factHours.toFixed(2)}</div>
                </div>
                <Grow in={this.state.isOpen}>
                    <div className={" " + (this.state.isOpen ? "" : "null-height")}>
                        {this.props.work.users && this.state.isOpen && this.props.work.users.map(w => <ExtendedHierarchicalProjectUserRow user={w} key={w.id} />)}

                    </div>
                </Grow >
            </div >

        )
    }
}

class ExtendedHierarchicalProjectUserRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        }
    }

    render() {
        return (
            <div className="extended-hierarchical-user-row" >
                <div className="extended-hierarchical-project-row-data clearfix">
                    <div className="extended-hierarchical-button">
                        {this.props.user.times && this.props.user.times.length > 0 &&
                            <IconButton size="small" onClick={() => { this.setState({ isOpen: !this.state.isOpen }); }}>
                                {this.state.isOpen ? <RemoveIcon fontSize="small" /> : <AddIcon fontSize="small" />}
                            </IconButton>}
                    </div>
                    <div className="extended-hierarchical-project-row-name" onClick={() => { this.setState({ isOpen: !this.state.isOpen }); }}>{this.props.user.name} {this.props.user.role}</div>
                    <div className="extended-hierarchical-project-row-time">{this.props.user.factHours.toFixed(2)}</div>
                </div>
                <Grow in={this.state.isOpen}>
                    <div className={" " + (this.state.isOpen ? "" : "null-height")}>
                        {this.props.user.times && this.state.isOpen && this.props.user.times.map(w => <ExtendedHierarchicalProjectUserTimeRow time={w} key={w.id} />)}
                    </div>
                </Grow >
            </div >

        )
    }
}

class ExtendedHierarchicalProjectUserTimeRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        }
    }

    render() {
        return (
            <div className="extended-hierarchical-time-row" >
                <div className="clearfix">
                    <div className="extended-hierarchical-project-row-name" onClick={() => { this.setState({ isOpen: !this.state.isOpen }); }}>{this.props.time.comment}</div>
                    <div className="extended-hierarchical-project-row-time">{this.props.time.factHours.toFixed(2)}</div>
                    <div className="extended-hierarchical-project-row-time">{this.props.time.date}</div>
                </div>
            </div >

        )
    }
}